import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { AUTH_ENDPOINTS } from '@/rtkQuery/config/authApi.config';
import { handleAuthError } from '@/rtkQuery/lib';
import type {
  ForgetPasswordApiResponse,
} from '@/rtkQuery/features/models/forgetPassword.model';

export const forgetPasswordApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({  

    forgotPassword: builder.mutation<ForgetPasswordApiResponse, string>({
      query: (email) => ({
        url: `${AUTH_ENDPOINTS.FORGOT_PASSWORD}?email=${encodeURIComponent(email)}`,
        method: 'POST',
      }),
      transformResponse: (response: ForgetPasswordApiResponse, meta) => {
        (meta as any).status = 'success';
        (meta as any).error = null;
        return response;
      },
      transformErrorResponse: (response: any, meta) => {
        const errorMessage = handleAuthError({
          message: response?.data?.Message || response?.data,
          status: response?.status,
        });

        (meta as any).status = 'error';
        (meta as any).error = errorMessage;

        return {
          status: response?.status,
          message: errorMessage,
          errors: response?.data?.errors || {},
        };
      },
      invalidatesTags: ['Auth'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useForgotPasswordMutation,
} = forgetPasswordApi;
